(function () {
  'use strict';
  var config = window.cbNoShipConfig;
  if (!config || (config.country !== 'SA' && config.country !== 'KW') || window.cbNoShipGuard) return;
  var handles = new Set(config.handles);
  var items = config.items;
  var originalTotalPrice = config.originalTotalPrice;
  var pending = 0, generation = 0, reading = null, uncertain = true;
  var token = 0, retryTimer = null, retryStep = 0, inactive = false;
  var attempt = null, replay = null, ready = null;
  var disabled = new Map(), concealed = new Map();
  var checkout = 'button[name="checkout"],input[name="checkout"],.cart__checkout,.custom_sticky_btn';
  var accelerated = '.additional-checkout-buttons,.shopify-payment-button,shopify-accelerated-checkout,shopify-accelerated-checkout-cart,[data-cb-noship-express]';
  var cards = '[data-product-handle],[data-cb2-reco-card],.cb2-card,.wl-row';
  var style = null;
  function restricted() { return items.filter(function (item) { return handles.has(item.handle); }); }
  function overCap() { return config.orderCap > 0 && originalTotalPrice > config.orderCap; }
  function locked() { return pending > 0 || reading !== null || uncertain || restricted().length > 0 || overCap(); }
  function urlOf(value) {
    try { return new URL(typeof value === 'string' ? value : value.url || String(value), window.location.href); }
    catch (_) { return null; }
  }
  function productHandle(url) {
    var parsed = urlOf(url), match = parsed && parsed.pathname.match(/\/products\/([^/]+?)(?:\.js|\.json)?\/?$/);
    try { return match ? decodeURIComponent(match[1]) : ''; } catch (_) { return ''; }
  }
  function mutation(value) {
    var u = urlOf(value);
    return u && u.origin === window.location.origin && (
      /\/cart\/(add|change|update|clear)(?:\.js)?\/?$/.test(u.pathname) ||
      // discount add/remove requests also change the paid total (Astra qa-20261024-final-hotfixes #1)
      (/\/checkout\/?$/.test(u.pathname) && u.searchParams.has('discount')) ||
      /\/discount\/[^/]+\/?$/.test(u.pathname));
  }
  function setAttr(el, key, value) { if (el.getAttribute(key) !== value) el.setAttribute(key, value); }
  function restore(el, key, value) { if (value === null) el.removeAttribute(key); else setAttr(el, key, value); }
  function cardHandle(el) {
    var card = el.closest(cards);
    if (!card) return '';
    return card.getAttribute('data-product-handle') || card.getAttribute('data-handle') ||
      productHandle((card.querySelector('a[href*="/products/"]') || {}).href || '');
  }
  function stop(event) { event.preventDefault(); event.stopImmediatePropagation(); }
  function focusNotice() {
    var list = document.querySelectorAll('[data-cb-noship-notice]');
    for (var i = 0; i < list.length; i++) {
      if (list[i].getClientRects().length) { list[i].focus(); return; }
    }
  }
  function makeNotice(lines, message) {
    var box = document.createElement('div');
    box.setAttribute('data-cb-noship-notice', '');
    box.setAttribute('role', 'alert'); box.setAttribute('tabindex', '-1');
    box.setAttribute('style', 'padding:16px;margin-block:12px;border:1px solid #9d352c;border-radius:8px;background:#fff6f4;color:#70231d');
    if (message) {
      var p = document.createElement('p'); p.textContent = message; box.appendChild(p);
    }
    if (overCap()) {
      var capNotice = document.createElement('p'); capNotice.setAttribute('data-cb-order-cap', '');
      capNotice.textContent = config.orderCapNotice; box.appendChild(capNotice);
    }
    if (lines.length) {
      var list = document.createElement('ul');
      lines.forEach(function (line) {
        var li = document.createElement('li'), title = document.createElement('span');
        title.setAttribute('dir', 'auto'); title.textContent = line.product_title || line.title;
        var remove = document.createElement('span'), link = document.createElement('a');
        remove.className = 'cart__remove'; link.className = 'text-link';
        link.href = config.changeUrl + '?id=' + encodeURIComponent(line.key) + '&quantity=0';
        link.textContent = config.remove; remove.appendChild(link);
        li.appendChild(title); li.appendChild(document.createTextNode(' ')); li.appendChild(remove); list.appendChild(li);
      });
      box.appendChild(list);
    }
    if (uncertain && !reading && !pending) {
      var retry = document.createElement('button');
      retry.setAttribute('type', 'button'); retry.setAttribute('data-cb-noship-retry', '');
      retry.textContent = config.retry; box.appendChild(retry);
    }
    return box;
  }
  function reconcile() {
    var hold = locked(), lines = restricted();
    document.querySelectorAll(checkout).forEach(function (el) {
      if (hold) {
        if (!disabled.has(el)) disabled.set(el, {
          disabled: el.hasAttribute('data-cb-noship-disabled') ? null : el.getAttribute('disabled'),
          aria: el.hasAttribute('data-cb-noship-disabled') ? null : el.getAttribute('aria-disabled')
        });
        setAttr(el, 'disabled', ''); setAttr(el, 'aria-disabled', 'true');
      } else if (el.hasAttribute('data-cb-noship-disabled') && !disabled.has(el)) {
        el.removeAttribute('disabled'); el.removeAttribute('aria-disabled'); el.removeAttribute('data-cb-noship-disabled');
      }
    });
    document.querySelectorAll(accelerated).forEach(function (el) {
      if (hold) {
        if (!concealed.has(el)) concealed.set(el, {
          hidden: el.hasAttribute('data-cb-noship-express') ? null : el.getAttribute('hidden'),
          inert: el.hasAttribute('data-cb-noship-express') ? null : el.getAttribute('inert'),
          aria: el.hasAttribute('data-cb-noship-express') ? null : el.getAttribute('aria-hidden')
        });
        setAttr(el, 'hidden', ''); setAttr(el, 'inert', ''); setAttr(el, 'aria-hidden', 'true');
      } else if (el.hasAttribute('data-cb-noship-express') && !concealed.has(el)) {
        el.removeAttribute('hidden'); el.removeAttribute('inert'); el.removeAttribute('aria-hidden'); el.removeAttribute('data-cb-noship-express');
      }
    });
    if (hold && !style) {
      style = document.createElement('style');
      style.textContent = accelerated + '{display:none!important;pointer-events:none!important}' + checkout + '{pointer-events:none!important}';
      document.head.appendChild(style);
    }
    if (!hold) {
      disabled.forEach(function (saved, el) {
        restore(el, 'disabled', saved.disabled); restore(el, 'aria-disabled', saved.aria);
        el.removeAttribute('data-cb-noship-disabled');
      }); disabled.clear();
      concealed.forEach(function (saved, el) {
        restore(el, 'hidden', saved.hidden); restore(el, 'inert', saved.inert); restore(el, 'aria-hidden', saved.aria);
        el.removeAttribute('data-cb-noship-express');
      }); concealed.clear();
      if (style) { style.remove(); style = null; }
    }
    // Discard detached elements without touching controls owned by other gates.
    disabled.forEach(function (_, el) { if (!el.isConnected) disabled.delete(el); });
    concealed.forEach(function (_, el) { if (!el.isConnected) concealed.delete(el); });
    var message = lines.length ? config.notice : reading || pending ? config.checking : uncertain ? config.error : '';
    var signature = JSON.stringify([message, overCap(), uncertain && !reading && !pending, lines.map(function (line) { return [line.key, line.product_title || line.title]; })]);
    document.querySelectorAll('#CartPageForm,#CartDrawerForm').forEach(function (form) {
      var notices = Array.from(form.querySelectorAll('[data-cb-noship-notice]'));
      if (!hold) { notices.forEach(function (node) { node.remove(); }); return; }
      if (notices.length === 1 && notices[0].getAttribute('data-cb-noship-state') === signature) return;
      notices.forEach(function (node) { node.remove(); });
      var notice = makeNotice(lines, message); notice.setAttribute('data-cb-noship-state', signature);
      (form.querySelector('[data-products]') || form).prepend(notice);
    });
    document.querySelectorAll(cards).forEach(function (card) {
      if (!handles.has(cardHandle(card))) return;
      setAttr(card, 'hidden', ''); setAttr(card, 'inert', '');
      card.querySelectorAll('button,input[type="submit"]').forEach(function (el) { setAttr(el, 'disabled', ''); });
    });
  }
  var nativeFetch = window.fetch;
  function clearRetry() {
    if (retryTimer !== null) clearTimeout(retryTimer);
    retryTimer = null;
  }
  function scheduleRetry() {
    if (!uncertain || inactive || document.hidden || pending || reading || retryTimer !== null) return;
    var delay = [500, 1000, 2000][retryStep++] || 5000;
    retryTimer = setTimeout(function () { retryTimer = null; refresh(); }, delay);
  }
  function invalidate() {
    clearReady();
    token++;
    if (!reading) return;
    var old = reading; reading = null;
    clearTimeout(old.timer);
    if (old.controller) old.controller.abort();
    old.resolve(false);
  }
  function destination(target) {
    return target.href || target.action || (target.form && target.form.action) || '';
  }
  function currentTarget(held) {
    return held.target.isConnected && (!held.submitter || held.submitter.isConnected) &&
      held.destination === destination(held.target);
  }
  function clearReady() {
    if (!ready) return;
    clearTimeout(ready.timer);
    restore(ready.held.target, 'aria-describedby', ready.description);
    ready.notice.remove(); ready = null;
  }
  function showReady(held, observed) {
    clearReady();
    var notice = document.createElement('p');
    notice.setAttribute('id', 'cb-noship-ready');
    notice.setAttribute('data-cb-noship-ready', '');
    notice.setAttribute('role', 'status');
    notice.setAttribute('aria-live', 'polite');
    notice.textContent = config.ready;
    var description = held.target.getAttribute('aria-describedby');
    ready = { held: held, generation: observed, notice: notice, description: description, expiresAt: Date.now() + 3000, timer: null };
    ready.timer = setTimeout(clearReady, 3000);
    setAttr(held.target, 'aria-describedby', (description ? description + ' ' : '') + 'cb-noship-ready');
    var surface = held.surface || held.target;
    (surface.parentNode || document.body).prepend(notice);
  }
  function acceptReady(event, target) {
    if (ready && Date.now() >= ready.expiresAt) { clearReady(); return false; }
    if (!ready || event.isTrusted !== true || locked() || ready.generation !== generation ||
        ready.held.target !== target || !currentTarget(ready.held)) return false;
    var held = ready.held;
    clearReady();
    // The native click may submit its form as its default action in this turn.
    var pass = { held: held, generation: generation, click: true, submit: false };
    replay = pass;
    setTimeout(function () { if (replay === pass) replay = null; }, 0);
    return true;
  }
  function replayAttempt(observed) {
    if (!attempt || locked() || observed !== generation) return;
    var held = attempt; attempt = null;
    if (!currentTarget(held)) return;
    if (held.trusted) { showReady(held, observed); return; }
    replay = { held: held, generation: observed, click: false, submit: false };
    try {
      if (held.continuation) held.continuation();
      else if (held.type === 'submit') {
        if (typeof held.target.requestSubmit === 'function') held.target.requestSubmit(held.submitter || undefined);
      } else {
        if (held.mouse && typeof MouseEvent === 'function') held.target.dispatchEvent(new MouseEvent('click', held.mouse));
        else held.target.click();
      }
    } finally { replay = null; }
  }
  function refresh() {
    clearRetry();
    invalidate();
    uncertain = true;
    if (pending || inactive) { reconcile(); return Promise.resolve(false); }
    var current = token, observed = generation;
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var resolveRead;
    var result = new Promise(function (resolve) { resolveRead = resolve; });
    var state = { token: current, controller: controller, resolve: resolveRead, timer: null };
    reading = state;
    function settle(cart) {
      if (token !== current || reading !== state) return;
      clearTimeout(state.timer); reading = null;
      var fresh = cart && observed === generation && pending === 0;
      if (fresh) {
        items = cart.items; originalTotalPrice = cart.total_price; uncertain = false; retryStep = 0;
        window.cbMarketCart = cart;
        if (typeof CustomEvent === 'function') document.dispatchEvent(new CustomEvent('cb:cart-verified'));
      }
      else { uncertain = true; }
      reconcile();
      resolveRead(!!fresh);
      if (fresh && (restricted().length || overCap())) attempt = null;
      if (fresh) replayAttempt(observed);
      else scheduleRetry();
    }
    state.timer = setTimeout(function () {
      if (controller) controller.abort();
      settle(null);
    }, 5000);
    Promise.resolve().then(function () {
      if (reading !== state) return null;
      var options = { credentials: 'same-origin', cache: 'no-store' };
      if (controller) options.signal = controller.signal;
      return nativeFetch.call(window, config.cartUrl + '.js', options);
    }).then(function (response) {
      if (reading !== state) return null;
      if (!response || !response.ok) throw new Error('Cart read failed');
      return response.json();
    }).then(function (cart) {
      if (reading !== state) return;
      if (!cart || !Array.isArray(cart.items) || cart.items.some(function (line) {
        return !line || typeof line.handle !== 'string' || !line.handle || typeof line.key !== 'string' || !line.key;
      })) throw new Error('Invalid cart');
      if (config.orderCap > 0 && (!Number.isSafeInteger(cart.total_price) ||
          cart.total_price < 0 || cart.currency !== config.orderCurrency)) throw new Error('Invalid cart total or currency');
      settle(cart);
    }).catch(function () { settle(null); });
    reconcile();
    return result;
  }
  function begin() { generation++; pending++; uncertain = true; clearRetry(); invalidate(); reconcile(); }
  function finish() { pending = Math.max(0, pending - 1); refresh(); }
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var u = urlOf(input);
      if (u && u.origin === window.location.origin && /\.js$/.test(u.pathname) && handles.has(productHandle(u.href))) {
        return Promise.resolve(new Response('{}', { status: 404, headers: { 'Content-Type': 'application/json' } }));
      }
      if (!mutation(input)) return nativeFetch.apply(this, arguments);
      begin();
      var result;
      try { result = nativeFetch.apply(this, arguments); }
      catch (error) { finish(); throw error; }
      return Promise.resolve(result).then(function (response) {
        finish(); return response;
      }, function (error) { finish(); throw error; });
    };
  }
  if (window.XMLHttpRequest) {
    var open = XMLHttpRequest.prototype.open, send = XMLHttpRequest.prototype.send;
    var requests = new WeakMap();
    XMLHttpRequest.prototype.open = function (method, url) { requests.set(this, mutation(url)); return open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      if (!requests.get(this)) return send.apply(this, arguments);
      begin(); var done = false;
      var settled = function () { if (!done) { done = true; finish(); } };
      this.addEventListener('loadend', settled, { once: true });
      try { return send.apply(this, arguments); } catch (error) { settled(); throw error; }
    };
  }
  function isCheckout(el) {
    if (el.closest(checkout + ',' + accelerated)) return true;
    var link = el.closest('a[href]'), u = link && urlOf(link.href);
    return u && u.origin === window.location.origin && /\/checkouts?(?:\/|$)/.test(u.pathname);
  }
  function activator(event) {
    var path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
    var target = null, surface = null, checkoutPath = false;
    path.forEach(function (node) {
      if (!node || typeof node.closest !== 'function') return;
      if (isCheckout(node)) checkoutPath = true;
      surface = surface || node.closest(accelerated);
      var native = node.closest('button,input[type="submit"],input[type="image"],a[href]');
      if (!target && native) target = native;
    });
    if (!checkoutPath) return null;
    // Opaque wallet hosts cannot expose their inner activator. Never replay them.
    target = target || surface;
    return target ? { target: target, surface: surface, trusted: !!surface } : null;
  }
  function heldAttempt(type, target, submitter) {
    return { type: type, target: target, submitter: submitter || null, destination: destination(target) };
  }
  function continueCheckout(type, target, submitter, continuation) {
    if ((type !== 'click' && type !== 'submit') || !target || typeof continuation !== 'function') return false;
    attempt = heldAttempt(type, target, submitter);
    attempt.continuation = continuation;
    attempt.surface = target.closest(accelerated);
    attempt.trusted = !!attempt.surface;
    refresh();
    return true;
  }
  function hold(event, type, target, submitter, control) {
    stop(event);
    if (!attempt) {
      attempt = heldAttempt(type, target, submitter);
      attempt.trusted = !!(control && control.trusted);
      attempt.surface = control && control.surface;
      attempt.mouse = type === 'click' && (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) ? {
        bubbles: true, cancelable: true, composed: true, view: window,
        ctrlKey: !!event.ctrlKey, metaKey: !!event.metaKey, shiftKey: !!event.shiftKey, altKey: !!event.altKey,
        button: event.button || 0, detail: event.detail || 0
      } : null;
    }
    refresh(); focusNotice();
  }
  function replayAllowed(type, target, submitter) {
    if (!replay || replay.generation !== generation || locked() || replay[type]) return false;
    var held = replay.held;
    var exact = type === 'click' ? held.type === 'click' && held.target === target :
      held.type === 'submit' ? held.target === target && held.submitter === (submitter || null) :
      held.target.form === target && held.target === submitter;
    if (!exact) return false;
    replay[type] = true; return true;
  }
  window.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    if (event.target.closest('[data-cb-noship-retry]')) { stop(event); refresh(); return; }
    var control = activator(event);
    if (control) {
      if (!replayAllowed('click', control.target) && !acceptReady(event, control.target)) {
        hold(event, 'click', control.target, null, control);
      }
      return;
    }
    var add = event.target.closest('[data-cb2-add],.grid_add_to_cart,[data-add-to-cart],[name="add"],[data-cb2-goto]');
    if (add && handles.has(cardHandle(add))) { stop(event); reconcile(); }
  }, true);
  window.addEventListener('submit', function (event) {
    var form = event.target, action = urlOf(form.action || window.location.href);
    if (!action) return;
    if (/\/cart\/add(?:\.js)?\/?$/.test(action.pathname) && handles.has(cardHandle(form))) { stop(event); return; }
    var button = event.submitter;
    var cartForm = form.id === 'CartPageForm' || form.id === 'CartDrawerForm' || /\/cart\/?$/.test(action.pathname);
    if (/\/checkouts?(?:\/|$)/.test(action.pathname) || (cartForm && (!button || button.name === 'checkout' || button.matches(checkout)))) {
      if (!replayAllowed('submit', form, button)) hold(event, 'submit', form, button);
    }
  }, true);
  // Theme events are hints, never accepted as a current cart snapshot.
  ['cart:updated', 'cart:build', 'ajaxProduct:added'].forEach(function (name) { document.addEventListener(name, refresh); });
  window.addEventListener('online', refresh);
  window.addEventListener('pagehide', function () {
    inactive = true; attempt = null; clearRetry(); invalidate(); uncertain = true;
  });
  window.addEventListener('pageshow', function () { inactive = false; attempt = null; refresh(); });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) clearRetry(); else { inactive = false; refresh(); }
  });
  var queued = false;
  new MutationObserver(function () {
    if (queued) return; queued = true;
    queueMicrotask(function () { queued = false; reconcile(); });
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'hidden', 'inert'] });
  document.addEventListener('DOMContentLoaded', reconcile);
  window.cbNoShipGuard = { blocked: locked, refresh: refresh, continueCheckout: continueCheckout };
  refresh();
})();
